import { templates } from './templates.ts';
import { CustomStepTemplate } from './TemplateSelector.types.ts';

/**
 * Get all templates available for a specific health category
 */
export const getTemplatesForHealthCategory = (healthCategoryId: string): CustomStepTemplate[] =>
  templates.filter(
    (template) =>
      template.healthCategories === 'ALL_CATEGORIES' || template.healthCategories.includes(healthCategoryId),
  );
